const map = {
	"./PADI-logo.png": 29199,
	"./campaign-icon.png": 52195,
	"./card-story-bg.png": 58029,
	"./check-success.png": 1581,
	"./close-white.png": 53007,
	"./complete.png": 39926,
	"./home-icon.png": 73618,
	"./lighten.png": 21606,
	"./new.png": 32097,
	"./no-list.png": 46325,
	"./tips.png": 51365,
	"./warning.png": 78671
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54862;